import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/images/loading-white.svg'
import _imports_1 from '@/images/arrow-load-more.png'


const _hoisted_1 = { class: "mt-6 flex items-center text-14px cursor-pointer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "bg-white bg-opacity-10 flex-1",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "px-4 opacity-50"
}
const _hoisted_4 = {
  key: 1,
  class: "px-4 opacity-50 hover:opacity-100 transition-opacity flex items-center"
}
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-5 h-5 animate-spin",
  alt: "loading"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-5 h-5",
  alt: "arrowLoad"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "bg-white bg-opacity-10 flex-1",
  style: {"height":"1px"}
}, null, -1)


import { useI18n } from 'vue-i18n'
interface Props {
  loading: boolean
  noMore: boolean
}
interface Emits {
  (e:'loadMore'):void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    loading: null,
    noMore: null
  },
  emits: ["loadMore"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e:'loadMore'):void
}), expose: any, slots: any, attrs: any }) {

const { t } = useI18n()




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (__props.noMore)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('no_more')), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('loading')), 1),
            _hoisted_6
          ], 512), [
            [_vShow, __props.loading]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "flex",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('loadMore')))
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('view_more')), 1),
            _hoisted_7
          ], 512), [
            [_vShow, !__props.loading]
          ])
        ])),
    _hoisted_8
  ]))
}
}

})